export default function checkMobile(): boolean {
  return window.innerWidth <= 768;
}
